"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Component = void 0;
const React = __importStar(require("react"));
const Elements = __importStar(require("../elements"));
class Component extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    componentWillMount() {
        this.windowHeight = Math.max((document.documentElement && document.documentElement.clientHeight) || 0, window.innerHeight || 0);
    }
    render() {
        const posX = this.props.left;
        const posY = this.props.top;
        const windowHeight = this.windowHeight;
        return (React.createElement(Elements.PopupComponentOverlay, { onClick: this.props.onClose },
            React.createElement(Elements.PopupComponentContainer, { onClick: stopPropagation, left: posX, top: posY, myRef: el => positionDiv(el, windowHeight) }, this.props.children)));
    }
}
exports.Component = Component;
function positionDiv(el, windowHeight) {
    if (!el) {
        return;
    }
    const clientRect = el.getBoundingClientRect();
    if (clientRect.bottom < windowHeight) {
        return;
    }
    const newYpos = clientRect.top - (clientRect.bottom - windowHeight);
    el.style.top = `${newYpos}px`;
}
function stopPropagation(e) {
    e.stopPropagation();
}
//# sourceMappingURL=component.js.map